import * as Sentry from '@sentry/react-native';
import Config from 'src/core/utils/Config';
import Constants from 'src/core/utils/Constants';

const TAG = '[SentryService] ->';

class SentryService {
	public constructor() {
		console.info(TAG, 'init()');
	}

	public init() {
		Sentry.init({
			dsn: Constants.sentryDsn,
			enabled: Config.environment !== Constants.sentryEnvironmentDevelopment,
			environment: Config.environment,
			release: Config.appVersion,
			tracesSampleRate: 0,
			profilesSampleRate: 0,
			ignoreErrors: [Constants.sentryErrorAxios],
			beforeBreadcrumb(breadcrumb) {
				if (breadcrumb.category === Constants.sentryBreadcrumbCategoryConsole) {
					return null;
				}
				return breadcrumb;
			},
			sendDefaultPii: false,
			beforeSend(event) {
				// PII scrubbing: never send identifying info (user, auth headers, query strings).
				if (event.user) {
					event.user = undefined;
				}
				if (event.request) {
					if (event.request.cookies) {
						delete event.request.cookies;
					}
					if (event.request.headers) {
						const headers = event.request.headers as Record<string, string>;
						delete headers.Authorization;
						delete headers.authorization;
					}
					if (typeof event.request.url === 'string') {
						event.request.url = event.request.url.split('?')[0];
					}
					event.request.query_string = undefined;
				}

				// Only forward fatal/error events.
				if (event.level === Constants.sentryEventLevelFatal || event.level === Constants.sentryEventLevelError) {
					return event;
				}
				return null;
			},
		});
	}

	public captureEvent({ message, extra }: { message: string; extra?: Record<string, unknown> }) {
		// Default captureMessage level is 'info', which beforeSend drops; send as 'error' so explicit captureEvent
		// reports actually reach Sentry.
		Sentry.captureMessage(message, { level: 'error', extra });
	}

	public captureException(error: unknown) {
		Sentry.captureException(error);
	}
}

export default new SentryService();
